import { Routes } from '@angular/router';
import { DashboardLayoutComponent } from '../../../shared/src/lib/components/layouts/dashboard-layout/dashboard-layout.component';

export const adminRoutes: Routes = [
  {
    path: '',
    component: DashboardLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./dashboard/dashboard.routes'),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('../../../shared/src/lib/components/profile/profile.component').then(
            (c) => c.ProfileComponent,
          ),
      },
      {
        path: 'access-denied',
        loadComponent: () =>
          import('../../../shared/src/lib/components/access-denied/access-denied.component').then(
            (c) => c.AccessDeniedComponent,
          ),
      },
    ],
  },
];
export const routes: Routes = [
  {
    path: 'tv',
    loadChildren: () => import('./tv/tv.routes'),
  },
  ...adminRoutes
];
